import { keepsLegacyCatalog, useHioBuyOnly } from '../../lib/marketMode';

// The site's home page ("/"). In HioBuy-only mode (lib/marketMode.js: a
// MARKET_PREVIEW build AND market_settings.marketplace_public on) a visitor or
// trader gets the marketplace as the home page; suppliers and admins keep the
// existing home page, and so does everyone while the setting is off. The
// services (managed request, quote request, صنّع فكرتك), orders and history
// stay where they are — the marketplace home links the services by the same
// routes. Turning the setting off restores the old home page, no deploy.
// Nothing renders until the switch is known, so nobody sees the wrong page flash.
export default function MarketHomeGate({ profile, legacy, market }) {
  const { ready, hioBuyOnly } = useHioBuyOnly();
  if (!ready) return null;
  return hioBuyOnly && market && !keepsLegacyCatalog(profile) ? market : legacy;
}
